import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_DOWNLOAD_DEALS } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetDownloadDeal = function*() {
  yield takeLatest(GET_DOWNLOAD_DEALS, workerGetDownloadDeal);
};

function* workerGetDownloadDeal(Param) {
  const result = yield call(getDownloadDeal, Param);
  yield put({ type: "SET_DOWNLOAD_DEALS", json: result.data });
}

function getDownloadDeal(Param) {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(
    apiUrl + "deals/listdownloaddeals?" + Param.params,
    options
  ).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
